import {__} from '@wordpress/i18n';
const socialLinks = [
    {value: "facebook", label: __("Facebook")},
    {value: "twitter", label: __("Twitter")},
    {value: "google", label: __("Google Currents")},
    {value: "pinterest", label: __("Pinterest")},
    {value: "linkedin", label: __("LinkedIn")},
    {value: "blogger", label: __("Blogger")},
    {value: "reddit", label: __("Reddit")},
    {value: "stumbleupon", label: __("StumbleUpon")},
    {value: "tumblr", label: __("Tumblr")},
    {value: "email", label: __("Email")},
    {value: "skype", label: __("Skype")},
    {value: "xing", label: __("Xing")}
]

export default socialLinks;